export const contactRouteNames = {
  default: 'contact-v2',
  smartList: 'contact-smart-list-v2',
  bulkActions: 'contact-bulk-actions-v2',
  duplicates: 'bulk-duplicate',
  specialCompanyDetail: 'special-company-contact-detail-v2',
  import: 'imports',
}
